const ONBOARDING_STORAGE_KEY = "tema_onboarding_profile";

export function saveOnboardingProfile(profile) {
  try {
    sessionStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(profile));
  } catch {
    // Ignore storage failures in private browsing.
  }
}

export function readOnboardingProfile() {
  try {
    const raw = sessionStorage.getItem(ONBOARDING_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearOnboardingProfile() {
  try {
    sessionStorage.removeItem(ONBOARDING_STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
}
